import React from 'react'

// components
import ResponsiveButton from 'components/atoms/ResponsiveButton'

const EditButton = props => {
  const { camper, reupRequired, align } = props

  const path = `/campers/${camper.id}/edit`
  const color = reupRequired && camper.confirmed ? 'primary' : 'secondary'

  return (
    <ResponsiveButton to={path} color={color} align={align}>
      {camper.confirmed ? 'Edit' : 'Confirm'}
    </ResponsiveButton>
  )
}

export default EditButton
